import type { IntlShape } from 'react-intl';
import type { EventNameType } from '@env0/notification-service/api.enum';

export const getEventDisplayText = (intl: IntlShape, eventName: EventNameType) =>
  intl.formatMessage({ id: `notification-settings.event-name.${eventName}` });
